import { render, staticRenderFns } from "./EditProfileDash.vue?vue&type=template&id=8b04d56c&scoped=true&"
import script from "./EditProfileDash.vue?vue&type=script&lang=js&"
export * from "./EditProfileDash.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileDash.vue?vue&type=style&index=0&id=8b04d56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b04d56c",
  null
  
)

export default component.exports